import { Stack, StackProps, styled } from '@mui/material';

import { generateClasses } from '../../../../utils/helper';

export const pollQuestionClasses = generateClasses('PollQuestion', [
  'questionDescription',
  'questionOptionsLabel',
  'questionOptions',
]);

/**
 * distributing padding among child is not possible to make symmetric layout as right part
 * because rich-text editor has background
 */
export const LeftPart = styled((props: StackProps) => <Stack gap={2} p={1} {...props} />)(({ theme }) => ({
  [`& .${pollQuestionClasses.questionDescription}`]: {
    flex: 1,
  },
}));

/**
 * distributing padding among child
 * instead of having padding on parent
 * to make room for padding around scrollbar
 */
export const RightPart = styled((props: StackProps) => <Stack gap={2} {...props} />)(({ theme }) => ({
  [`& .${pollQuestionClasses.questionOptionsLabel}`]: {
    padding: theme.spacing(1),
    paddingBottom: 0,
  },
  [`& .${pollQuestionClasses.questionOptions}`]: {
    flex: 1,
    padding: theme.spacing(1),
    paddingTop: 0,
  },
}));
